import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '~/environments/environment';

export interface OauthClient {
    client_id: string;
    client_name: string;
    client_uri?: string;
    logo_uri?: string;
    redirect_uris: string[];
}

// Paramètres OAuth reçus en query par la page de consentement, transmis tels quels à l'API.
export interface OauthAuthorizeRequest {
    client_id: string;
    redirect_uri: string;
    response_type: string;
    state: string;
    scope: string;
    code_challenge: string;
    code_challenge_method: string;
    resource?: string;
}

@Injectable({
    providedIn: 'root'
})
export class OauthService {
    constructor(private http: HttpClient) {
    }

    // Public (sans jeton) : 404 si le client est inconnu.
    getClient(clientId: string): Observable<OauthClient> {
        return this.http.get<OauthClient>(`${environment.apiUrl}oauth/client/${encodeURIComponent(clientId)}`);
    }

    // JWT posé par jwt.interceptor. 200 → {redirect_uri}, 400 → {error, error_description}, 401 → jeton absent/périmé.
    authorize(request: OauthAuthorizeRequest): Observable<{ redirect_uri: string }> {
        return this.http.post<{ redirect_uri: string }>(`${environment.apiUrl}app/oauth/authorize`, request);
    }
}
